/**
 * EAA-1736: Shared descriptor for the media layout options, used by both the
 * media bubble menu and the right-click context menu so the two surfaces stay
 * in sync (same icons, labels, order).
 */

import * as React from 'react';
import {
    Baseline,
    BringToFront,
    PanelLeft,
    PanelRight,
    RectangleHorizontal,
    SendToBack,
} from 'lucide-react';
import type { MediaLayout } from '../../../lib/tiptap-media-layout';

export interface MediaLayoutOption {
    layout: MediaLayout;
    icon: React.ComponentType<{ className?: string }>;
    /** kit translation key. */
    labelKey: string;
    labelFallback: string;
}

export const MEDIA_LAYOUT_OPTIONS: readonly MediaLayoutOption[] = [
    { layout: 'inline', icon: Baseline, labelKey: 'kRtmLayoutInline', labelFallback: 'Inline' },
    {
        layout: 'block',
        icon: RectangleHorizontal,
        labelKey: 'kRtmLayoutBlock',
        labelFallback: 'Block',
    },
    {
        layout: 'wrap-left',
        icon: PanelLeft,
        labelKey: 'kRtmLayoutWrapLeft',
        labelFallback: 'Wrap left',
    },
    {
        layout: 'wrap-right',
        icon: PanelRight,
        labelKey: 'kRtmLayoutWrapRight',
        labelFallback: 'Wrap right',
    },
    {
        layout: 'behind',
        icon: SendToBack,
        labelKey: 'kRtmLayoutBehind',
        labelFallback: 'Behind text',
    },
    {
        layout: 'front',
        icon: BringToFront,
        labelKey: 'kRtmLayoutFront',
        labelFallback: 'In front of text',
    },
];
